<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

         <!-- HEADER -->
         <div class="header accent"
         fxLayout="column" fxLayoutAlign="center center"
         fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

        <!-- TÍTULO E BOTÕES -->
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0"
                 fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    business
                </mat-icon>
                <span class="logo-text h1">
                    Saldo de Clientes (Corretora)
                </span>
                
                <!-- BOTÕES DE AÇÃO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                    <!-- BOTÃO CONSULTAR -->
                    <button mat-mini-fab 
                            color="accent"
                            matTooltip="Consultar Saldo"
                            (click)="openFiltro()">
                        <mat-icon>search</mat-icon>
                    </button>
                    
                    <!-- BOTÃO IMPORTAR -->
                    <button *ngIf='user.role_id == 2 || user.role_id == 7 || user.role_id == 4'
                            mat-mini-fab 
                            color="accent"
                            matTooltip="Importar Saldo"
                            (click)="openCadastro()">
                        <mat-icon>cloud_upload</mat-icon>
                    </button>
                    
                    <!-- BOTÃO EXPORTAR -->
                    <button mat-mini-fab 
                            color="accent"
                            matTooltip="Exportar Saldo"
                            (click)="exportarSaldo()">
                        <mat-icon>cloud_download</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <!-- SEARCH -->
        <div class="search-wrapper mx-32 mx-md-0">
            <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">                    
                <input 
                    #filter 
                    placeholder="Buscar Por Nome, CPF ou Conta"
                    [formControl]="search"
                    (keyup)="onEnter(filter.value)"
                    (keyup.enter)="onEnter(filter.value)"
                >
                <mat-icon 
                    style="cursor: pointer;" 
                    (click)="getAll()"
                >
                    search
                </mat-icon>
            </div>
        </div>                    
        <!-- / SEARCH -->

    </div>
    <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" >
            <mat-card>                
                <mat-card-content class="custom-datatable">
                    <ngx-datatable 
                        #table 
                        class='material' 
                        [loadingIndicator]="loadingIndicator"
                        [columns]="columns" 
                        [columnMode]="'force'" 
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [rowHeight]="'auto'"
                        [rowClass]="getRowClass"
                        [limit]="params.per_page"
                        [rows]='rows'                        
                        (sort)="onSort($event)">

                        <ngx-datatable-column name="Hora" prop="data_hora_atualizacao" [sortable]="false" [width]="80">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template >
                                <span class="texto">
                                    {{row.data_hora_importacao | date:'dd/MM/yyyy H:mm'}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>                

                        <ngx-datatable-column name="Cliente" prop="nome" [sortable]="true" [width]="200">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                <span *ngIf='row.homebroker'>
                                    <mat-chip class="chip" color="primary" selected >HB</mat-chip>
                                </span>
                                <span class="texto">
                                    {{row.cliente.numero_xp}} - {{row.cliente.nome}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Escritório" prop="escritorio_id" [sortable]="true" [width]='100' *ngIf="this.user.role_id != 5 ">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                <span class="texto">
                                    {{ getEscritorioCliente(row) }} 
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Assessor" prop="assessor_id" [sortable]="true" *ngIf="this.user.role_id != 5 ">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                <span class="texto">
                                    {{ getAssessorCliente(row) }}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="D0" prop="saldo_d0" [sortable]="true" [width]="80">
                            <ng-template let-rowIndex="rowIndex" let-saldo_d0="value" ngx-datatable-cell-template>
                                <span class="texto">
                                    {{saldo_d0 | number : '1.2-2'}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="D+1" prop="saldo_d1" [sortable]="true"  [width]="50">
                            <ng-template let-rowIndex="rowIndex" let-saldo_d1="value" ngx-datatable-cell-template>
                                <span class="texto">
                                    {{saldo_d1 | number : '1.2-2'}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="D+2" prop="saldo_d2" [sortable]="true" [width]="60">
                            <ng-template let-rowIndex="rowIndex" let-saldo_d2="value" ngx-datatable-cell-template>
                                <span class="texto">
                                    {{saldo_d2 | number : '1.2-2'}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="D+3" prop="saldo_d3" [sortable]="true" [width]="60">
                            <ng-template let-rowIndex="rowIndex" let-saldo_d3="value" ngx-datatable-cell-template>
                                <span class="texto">
                                    {{ saldo_d3 | number : '1.2-2'}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Total" prop="saldo_total" [sortable]="false" [width]="100">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                <span class="texto">
                                    {{ getSaldoTotal(row) | number : '1.2-2'}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>                       
                        

                    </ngx-datatable>
                    <div style="padding: 5px 10px">
                        <mat-paginator 
                            #paginator 
                            [length]="length"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions"
                            (page)="pageEvent($event)">
                        </mat-paginator>
                    </div>
                </mat-card-content>
            </mat-card>           
        </div>
    </div>
</div>